var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');
var Utils = require('front/utils/Utils');

var template = require('./PaintingsContentAll.jinja');
require('./PaintingsContentAll.less');

module.exports = Backbone.View.extend({


    IMAGE_WIDTH: 2000,
    IMAGE_HEIGHT: 1400,
    STROKE_SIZE: 12, //8 слишком мало, из-за округлений строуки получаются слишком узкими для расчетов

    initialize: function (options) {
        _.extend(this, options);

        _.bindAll(this, 'onResize');
    },


    activate: function (params) {
        console.log('activate PaintingsContentAll');

        _.bindAll(this, 'onMousemove', 'onMouseleave');

        this.parent = params.parent;

        if (!this.$dom) {
            this.$dom = $(template.render({data: {}}));

            this.$dom.appendTo(params.$parent);

            $.ajax({
                'url': app.settings.api_url + this.paintingId + '.json',
                'method': 'GET',
                'success': this.onApiSuccess,
                'error': this.onApiError,
                'context': this
            });
        } else {
            //просто вставляем дум обратно в контейнер
            this.$dom.appendTo(params.$parent);
            this.onResize();
        }

        $(window).on('resize', this.onResize);
    },


    onApiSuccess: function (data) {

        if (data.error) {
            delete this.$dom;
            Backbone.history.navigate('/', {trigger: 'true'});

            return;
        }

        this.data = data;

        this.userImages = [];
        this.userImagesMap = {};

        for (var i = 0; i < data.s.length; i++) {
            this.userImages[i] = {
                src: window.app.settings.people_image_url.replace('##', data.s[i].p).replace('#', this.paintingId)
            };

            //для удобства у нас картинки в userImages идут просто по очереди (просто неизвестно какая нумерация у айдишников людей)
            //а userImagesMap это меппер, с айдишников на индекс в userImages
            this.userImagesMap[data.s[i].p] = i;
        }

        this.loadUsersImages();
    },


    loadUsersImages: function () {
        var queued = 0;
        var curImage = 0;
        var self = this;
        var totalLoaded = 0;

        for (var i = 0; i < 5; i++) {
            addImageToQueue();
        }

        function addImageToQueue() {
            if (curImage == self.userImages.length) {

                if (!queued) {
                    self.imagesReady();
                }

                return;
            }

            var part = new Image();
            var imageIndex = curImage;

            var loadFunction = function () {
                part.onload = null;
                self.userImages[imageIndex].img = part;
                queued--;
                totalLoaded++;

                self.$dom.find('.PaintingsContentAll-loader').text(Math.round(100 * totalLoaded / self.userImages.length));

                addImageToQueue();
            };

            part.onload = loadFunction;
            part.onerror = loadFunction;

            part.src = self.userImages[imageIndex].src;

            queued++;
            curImage++;
        }
    },


    imagesReady: function () {

        this.$dom.removeClass('PaintingsContentAll--loading');

        this.onResize();

        this.$dom.on('mousemove', this.onMousemove);

        this.$dom.on('mouseleave', this.onMouseleave);

        this.clusters = {};

        var data = this.data;

        for (var i = 0; i < data.s.length; i++) {
            var peopleStrokes = data.s[i].c;
            var peopleId = data.s[i].p;

            for (var j = 0; j < peopleStrokes.length; j++) {
                var strokeCoords = peopleStrokes[j];

                //переводим относительные строуки в абсолютные координаты картины
                //только с нимим и можно нормально работать из-за размера штриха
                //в относительных размераз ширина штриза по горизонтали и вертикали будет разниться
                //для горизонтального будет 8/1400, для вертикального 8/2000, а для повернутого будет микс, нахрен такие расчеты
                strokeCoords[0] = Math.round(strokeCoords[0] / 10000 * this.IMAGE_WIDTH);
                strokeCoords[1] = Math.round(strokeCoords[1] / 10000 * this.IMAGE_HEIGHT);
                strokeCoords[2] = Math.round(strokeCoords[2] / 10000 * this.IMAGE_WIDTH);
                strokeCoords[3] = Math.round(strokeCoords[3] / 10000 * this.IMAGE_HEIGHT);

                //для каждого строука находим boundingBox, но не точный, а приблизительный
                //но точно не меньше настоящего bb
                var x1 = Math.max(Math.min(strokeCoords[0], strokeCoords[2]) - this.STROKE_SIZE, 0);
                var y1 = Math.max(Math.min(strokeCoords[1], strokeCoords[3]) - this.STROKE_SIZE, 0);
                var x2 = Math.max(strokeCoords[0], strokeCoords[2]) + this.STROKE_SIZE;
                var y2 = Math.max(strokeCoords[1], strokeCoords[3]) + this.STROKE_SIZE;

                //разбиваем нашу картинку на кластеры (квадраты по 128 пикселей, степень двойки для быстрой математики)
                //и смотрим в какие кластеры попадает данный мазок, обычно это один кластер,
                //в худшем случае один мазок может быть сразу в 4х кластерах, но это будет в нескольких десятках случаев

                var clusters = {};
                clusters[(x1 >> 7) + '_' + (y1 >> 7)] = 1; //кластер для правого верхнего угла bb, ну и дальше по аналогии
                clusters[(x2 >> 7) + '_' + (y1 >> 7)] = 1;
                clusters[(x1 >> 7) + '_' + (y2 >> 7)] = 1;
                clusters[(x2 >> 7) + '_' + (y2 >> 7)] = 1;


                //превращаем линию с известной толщиной в прямоугольник с 4мя координатами углов
                x1 = strokeCoords[0];
                y1 = strokeCoords[1];
                x2 = strokeCoords[2];
                y2 = strokeCoords[3];

                var dx = x2 - x1;
                var dy = y2 - y1;

                //длина линии
                var len = Math.pow(dx * dx + dy * dy, 0.5);

                if (len == 0) {
                    len = this.STROKE_SIZE;
                    dy = this.STROKE_SIZE;
                }

                //вектора сторон единичные
                var nx = dx / len;
                var ny = dy / len;

                //из обоих конечных точек линии в противоположные стороны перпендикулярно самой линии выводим отрезки длиной в пол строука
                //по часовой стрелке ведем
                var region = [
                    {
                        x: Math.round(x1 - ny * this.STROKE_SIZE / 2),
                        y: Math.round(y1 + nx * this.STROKE_SIZE / 2)
                    },
                    {
                        x: Math.round(x1 + ny * this.STROKE_SIZE / 2),
                        y: Math.round(y1 - nx * this.STROKE_SIZE / 2)
                    },
                    {
                        x: Math.round(x2 + ny * this.STROKE_SIZE / 2),
                        y: Math.round(y2 - nx * this.STROKE_SIZE / 2)
                    },
                    {
                        x: Math.round(x2 - ny * this.STROKE_SIZE / 2),
                        y: Math.round(y2 + nx * this.STROKE_SIZE / 2)
                    }
                ];

                //в каждый кластер которому принадлежит строук прописываем этот строук
                //прописывать указатели на реальные строуки из this.data мне кажется неправильным
                //потому что при переборе при движении мыши получение каждого строука из кластера где сейчас мышь будет несколько дольше
                //из-за промахов кеша
                for (var clusterKey in clusters) {
                    this.clusters[clusterKey] = this.clusters[clusterKey] || [];

                    var cluster = this.clusters[clusterKey];

                    cluster[cluster.length] = {
                        p: peopleId,
                        r: region
                    };
                }
            }
        }


        this.$dom
            .find('.PaintingsContentAll-paintingImage')
            .css('background-image', 'url(' + window.app.settings.image_folder + this.data.i + ')');
    },


    onMousemove: function (e) {
        var x = Math.round(e.offsetX);
        var y = Math.round(e.offsetY);

        if (!this.mouseMoved) {
            this.$dom.find('.PaintingsContentAll-user')
                .removeClass('PaintingsContentAll-user--hidden');
            this.mouseMoved = true;
        }

        this.$dom.find('.PaintingsContentAll-user')
            .css({
                left: x,
                top: y
            })
            .toggleClass('PaintingsContentAll-user--position-bottom', y < 150)
            .toggleClass('PaintingsContentAll-user--position-top', y >= 150)
            .toggleClass('PaintingsContentAll-user--position-right', x < 80)
            .toggleClass('PaintingsContentAll-user--position-left', x >= this.domSizes.w - 80);

        //переводим координаты мыши в координаты исходной картины (2000х1400)
        //у нас сктроуки в тех координатах
        var p = {
            x: x * this.IMAGE_WIDTH / this.domSizes.w,
            y: y * this.IMAGE_HEIGHT / this.domSizes.h
        };

        //находим кластер к которому относится положение мыши
        var cluster = this.clusters[(p.x >> 7) + '_' + (p.y >> 7)] || [];
        var found = false;

        var maxUserId = -1;

        //перебираем все строуки из этого кластера, их обычно не больше 200
        //так что перебор ненапряжный
        for (var i = 0; i < cluster.length; i++) {
            var stroke = cluster[i];
            if (isConvexPolygonContainsPoint(stroke.r, p)) {
                maxUserId = Math.max(maxUserId, stroke.p);
            }
        }

        //не нашли принадлежности строука юзеру
        //либо попали в пустое место холста, либо строук нарисован роботом без участия юзера
        if (maxUserId == -1) {
            this.$dom.find('.PaintingsContentAll-user').addClass('PaintingsContentAll-user--imageHidden');
        } else {
            this.$dom.find('.PaintingsContentAll-userImage').html(this.userImages[this.userImagesMap[maxUserId]].img);
            this.$dom.find('.PaintingsContentAll-user').removeClass('PaintingsContentAll-user--imageHidden');
        }

        //векторное произведение
        function calcOrientedTriangleSquare(a, b, c) {
            return (b.x - a.x) * (c.y - a.y) - (b.y - a.y) * (c.x - a.x);
        }

        //проверка нахождения точки внутри выпуклого полигона либо на его границе
        function isConvexPolygonContainsPoint(r, p) {
            for (var i = 0; i < r.length; i++) {
                var j = (i + 1) % r.length;
                if (calcOrientedTriangleSquare(r[i], r[j], p) < 0) return false;
            }

            return true;
        }
    },


    onMouseleave: function (e) {
        this.$dom.find('.PaintingsContentAll-user')
            .addClass('PaintingsContentAll-user--hidden');
        this.mouseMoved = false;
    },


    onResize: function () {
        //position user and classes
        this.domSizes = {
            w: this.$dom.width(),
            h: this.$dom.height()
        };
    },


    onApiError: function () {
        console.log(arguments);
    },


    deactivate: function (params) {
        console.log('deactivate PaintingsContentAll');
        this.$dom.detach();

        $(window).off('resize', this.onResize);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Index/PaintingsContentAll.js
// module id = 30
// module chunks = 0